import { get, put } from '@/api/apiService.ts';
import type { ScoringCriterion, UpdateScoringCriterion } from '@/types/scoring.ts';

const scoringService = {
  getCriteria(): Promise<ScoringCriterion[]> {
    return get<ScoringCriterion[]>('/api/scoring-criteria');
  },

  updateCriteria(criteria: UpdateScoringCriterion[]): Promise<ScoringCriterion[]> {
    return put<{ criteria: UpdateScoringCriterion[] }, ScoringCriterion[]>(
      '/api/scoring-criteria',
      { criteria },
    );
  },
};

export default scoringService;
